import script from "./RmsIdSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmsIdSelector.vue?vue&type=script&setup=true&lang=ts"

import "./RmsIdSelector.vue?vue&type=style&index=0&id=41dc8ae4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41dc8ae4"]])

export default __exports__